import Global from './GlobalState';

export default {
	states: {
		...Global.states
	},
	actions: {
		...Global.actions
	}
}